import React from 'react';
import { Link } from 'react-router-dom';

const PersonalizedTestHeader = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Breadcrumbs */}
      <div className="flex items-center gap-2 text-sm">
        <Link className="text-slate-500 hover:text-primary-blue transition-colors" to="/dashboard">Trang chủ</Link>
        <span className="text-slate-400">/</span>
        <span className="text-slate-800 dark:text-white font-medium">Bài thi cá nhân hóa</span>
      </div>
      {/* Page Heading */}
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div className="flex flex-col gap-2">
          <h2 className="text-3xl md:text-4xl font-black tracking-tight text-slate-900 dark:text-white">Bài thi cá nhân hóa</h2>
          <p className="text-slate-500 dark:text-slate-400 text-base max-w-2xl">Bài thi được thiết kế riêng theo tiến độ học tập và trọng tâm của bạn.</p>
        </div>
      </div>
    </div>
  );
}

export default PersonalizedTestHeader;
